<template>
    <v-data-table :items="statusAction" :headers="statusActionHeaders" :items-per-page="-1">
    </v-data-table>
</template>

<script>
export default {
    name: 'TabLog',
    props: {
        statusAction: Array,
        statusActionHeaders: Array
    }
}
</script>
